/**
 * ActivityFeed — List of recent case activity.
 *
 * Props:
 *   items: Array<{
 *     id: string | number,
 *     icon: ReactNode,
 *     title: string,
 *     detail: string,
 *     time: string,
 *     onClick: () => void (optional)
 *   }>
 *   title: string — section header (optional)
 */

import React from 'react';
import Card from './Card';
import styles from './ActivityFeed.module.css';

function ActivityFeed({ items = [], title }) {
  if (items.length === 0) return null;

  return (
    <div>
      {title && <h2 className={styles.title}>{title}</h2>}
      <Card padding="none">
        {items.map((item, idx) => (
          <div
            key={item.id || idx}
            className={styles.item}
            onClick={item.onClick}
            role={item.onClick ? 'button' : undefined}
            tabIndex={item.onClick ? 0 : undefined}
          >
            <div className={styles.icon}>
              {item.icon}
            </div>
            <div className={styles.text}>
              <div className={styles.itemTitle}>{item.title}</div>
              {item.detail && (
                <div className={styles.detail}>{item.detail}</div>
              )}
            </div>
            <div className={styles.time}>{item.time}</div>
          </div>
        ))}
      </Card>
    </div>
  );
}

export default ActivityFeed;
